module.exports = __webpack_public_path__ + "img/estop.9e4754e5.svg";